// Knights Five Data - Group Five (Final Regional & Specialized Knights)

// Sir Pelleas the Younger's workout programs
const pelleasYoungerPrograms = [
    {
        id: 'nephew-legacy-training',
        name: 'Nephew Legacy Training',
        description: 'Following in the footsteps of greatness while forging your own path',
        pattern: '<[}):*',
        reps: 12,
        sets: 6,
        focus: 'Legacy Building'
    },
    {
        id: 'silver-moon-conditioning',
        name: 'Silver Moon Conditioning',
        description: 'Lunar-powered strength training that waxes with youthful potential',
        pattern: '*<[}):',
        reps: 14,
        sets: 5,
        focus: 'Youthful Potential'
    },
    {
        id: 'learning-knight-protocol',
        name: 'Learning Knight Protocol',
        description: 'Eager conditioning that grows stronger with each passing day',
        pattern: '):[}<*',
        reps: 16,
        sets: 4,
        focus: 'Continuous Growth'
    },
    {
        id: 'grey-destrier-strength',
        name: 'Grey Destrier Strength',
        description: 'Young mount conditioning for horses still learning the ways of war',
        pattern: '}*:<[)',
        reps: 13,
        sets: 5,
        focus: 'Learning Partnership'
    },
    {
        id: 'idealistic-youth-training',
        name: 'Idealistic Youth Training',
        description: 'Hopeful conditioning that believes in the possibility of perfection',
        pattern: '[[}}::',
        reps: 18,
        sets: 4,
        focus: 'Hopeful Idealism'
    },
    {
        id: 'future-greatness-mastery',
        name: 'Future Greatness Mastery',
        description: 'The complete training for a knight destined to surpass his mentor',
        pattern: '<[}):*!!',
        reps: 20,
        sets: 3,
        focus: 'Destined Greatness'
    }
];

// Sir Cador of Cornwall's workout programs
const cadorPrograms = [
    {
        id: 'cornish-lord-training',
        name: 'Cornish Lord Training',
        description: 'Regional leadership conditioning for ruling the rugged Cornwall peninsula',
        pattern: '>[{:-+',
        reps: 17,
        sets: 4,
        focus: 'Regional Command'
    },
    {
        id: 'black-gold-conditioning',
        name: 'Black and Gold Conditioning',
        description: 'Royal Cornish colors representing ancient power and modern wealth',
        pattern: '+>[{:-',
        reps: 19,
        sets: 3,
        focus: 'Ancient Wealth'
    },
    {
        id: 'coastal-fortress-protocol',
        name: 'Coastal Fortress Protocol',
        description: 'Maritime strength training for defending rocky shores and sea approaches',
        pattern: ':-+>[{',
        reps: 21,
        sets: 3,
        focus: 'Maritime Defense'
    },
    {
        id: 'noble-bearing-strength',
        name: 'Noble Bearing Strength',
        description: 'Distinguished conditioning that commands respect through presence alone',
        pattern: '{:->[+',
        reps: 15,
        sets: 5,
        focus: 'Noble Presence'
    },
    {
        id: 'cornwall-heritage-training',
        name: 'Cornwall Heritage Training',
        description: 'Ancient bloodline conditioning passed down through generations of rulers',
        pattern: '>>{{:-',
        reps: 23,
        sets: 3,
        focus: 'Ancient Bloodline'
    },
    {
        id: 'regional-mastery-conditioning',
        name: 'Regional Mastery Conditioning',
        description: 'The ultimate training for those who rule wild and beautiful lands',
        pattern: '>[{:-+!!',
        reps: 25,
        sets: 3,
        focus: 'Land Mastery'
    }
];

// Sir Constantine of Britain's workout programs
const constantinePrograms = [
    {
        id: 'british-heritage-training',
        name: 'British Heritage Training',
        description: 'Ancient bloodline conditioning from the old tribes of Britain',
        pattern: ';|*:>+',
        reps: 16,
        sets: 4,
        focus: 'Ancient Heritage'
    },
    {
        id: 'celtic-knot-conditioning',
        name: 'Celtic Knot Conditioning',
        description: 'Interwoven strength patterns inspired by sacred Celtic designs',
        pattern: '+;|*:>',
        reps: 18,
        sets: 4,
        focus: 'Sacred Patterns'
    },
    {
        id: 'eagle-wings-protocol',
        name: 'Eagle Wings Protocol',
        description: 'Soaring strength training that embodies the silver eagle of Britain',
        pattern: '>:*|;+',
        reps: 14,
        sets: 5,
        focus: 'Soaring Power'
    },
    {
        id: 'ancestral-sword-strength',
        name: 'Ancestral Sword Strength',
        description: 'Generational conditioning for weapons passed down through bloodlines',
        pattern: '*|>+;:',
        reps: 20,
        sets: 3,
        focus: 'Ancestral Weapons'
    },
    {
        id: 'british-war-horse-training',
        name: 'British War Horse Training',
        description: 'Native mount conditioning for the strongest horses of the isles',
        pattern: ';;||**',
        reps: 22,
        sets: 3,
        focus: 'Native Strength'
    },
    {
        id: 'tribal-mastery-conditioning',
        name: 'Tribal Mastery Conditioning',
        description: 'The complete training connecting modern knights to ancient tribal warriors',
        pattern: ';|*:>+!!',
        reps: 24,
        sets: 3,
        focus: 'Tribal Connection'
    }
];

// Sir Lucan the Butler's workout programs
const lucanPrograms = [
    {
        id: 'loyal-butler-training',
        name: 'Loyal Butler Training',
        description: 'Service-oriented conditioning that combines duty with deadly effectiveness',
        pattern: '=(}[-*',
        reps: 13,
        sets: 6,
        focus: 'Dutiful Service'
    },
    {
        id: 'royal-service-conditioning',
        name: 'Royal Service Conditioning',
        description: 'Administrative strength training for managing both court and combat',
        pattern: '*=(}[-',
        reps: 15,
        sets: 5,
        focus: 'Administrative Power'
    },
    {
        id: 'key-bearer-protocol',
        name: 'Key Bearer Protocol',
        description: 'Trusted conditioning for those who hold the keys to power',
        pattern: '[-*=(}',
        reps: 17,
        sets: 4,
        focus: 'Trusted Authority'
    },
    {
        id: 'competent-reliability-strength',
        name: 'Competent Reliability Strength',
        description: 'Steadfast conditioning that never fails when others depend on it',
        pattern: '}=(-[*',
        reps: 19,
        sets: 3,
        focus: 'Unwavering Competence'
    },
    {
        id: 'brown-courser-training',
        name: 'Brown Courser Training',
        description: 'Dependable mount conditioning for horses suited to long, faithful service',
        pattern: '==}}[[',
        reps: 21,
        sets: 3,
        focus: 'Faithful Service'
    },
    {
        id: 'arthur-servant-mastery',
        name: 'Arthur\'s Servant Mastery',
        description: 'The ultimate training for those who serve the greatest of all kings',
        pattern: '=(}[-*!!',
        reps: 23,
        sets: 3,
        focus: 'Royal Devotion'
    }
];

// Sir Palamedes the Saracen's workout programs
const palamedesPrograms = [
    {
        id: 'saracen-champion-training',
        name: 'Saracen Champion Training',
        description: 'Eastern excellence that rivals the greatest knights of the West',
        pattern: '{+<)-;',
        reps: 18,
        sets: 4,
        focus: 'Eastern Excellence'
    },
    {
        id: 'damascus-mastery-conditioning',
        name: 'Damascus Mastery Conditioning',
        description: 'Superior steel conditioning using the finest metallurgy of the East',
        pattern: ';{+<)-',
        reps: 20,
        sets: 3,
        focus: 'Steel Mastery'
    },
    {
        id: 'peacock-nobility-protocol',
        name: 'Peacock Nobility Protocol',
        description: 'Magnificent conditioning that displays the beauty of Eastern chivalry',
        pattern: ')-;{+<',
        reps: 16,
        sets: 5,
        focus: 'Magnificent Display'
    },
    {
        id: 'crescent-moon-strength',
        name: 'Crescent Moon Strength',
        description: 'Lunar-powered training that bridges Eastern mysticism and Western valor',
        pattern: '<+{;)-',
        reps: 22,
        sets: 3,
        focus: 'Mystical Bridge'
    },
    {
        id: 'arabian-magnificence-training',
        name: 'Arabian Magnificence Training',
        description: 'Desert-bred conditioning for the finest stallions of the Eastern lands',
        pattern: '{{++<)',
        reps: 24,
        sets: 3,
        focus: 'Desert Magnificence'
    },
    {
        id: 'eastern-nobility-mastery',
        name: 'Eastern Nobility Mastery',
        description: 'The complete training that proves Eastern chivalry equals any in the world',
        pattern: '{+<)-;!!',
        reps: 26,
        sets: 3,
        focus: 'Universal Chivalry'
    }
];

// Sir Gaheris of Orkney's workout programs
const gaherisPrograms = [
    {
        id: 'stealthy-brother-training',
        name: 'Stealthy Brother Training',
        description: 'Shadow conditioning for the most cunning of Gawain\'s brothers',
        pattern: '>=-)+[',
        reps: 14,
        sets: 5,
        focus: 'Shadow Cunning'
    },
    {
        id: 'silver-wolf-conditioning',
        name: 'Silver Wolf Conditioning',
        description: 'Pack hunter strength training with the stealth of lone wolves',
        pattern: '[>=-)+',
        reps: 17,
        sets: 4,
        focus: 'Lone Wolf'
    },
    {
        id: 'darkened-mail-protocol',
        name: 'Darkened Mail Protocol',
        description: 'Concealment conditioning using armor blackened for stealth operations',
        pattern: '+)=->[',
        reps: 15,
        sets: 4,
        focus: 'Stealth Operations'
    },
    {
        id: 'twin-sword-strength',
        name: 'Twin Sword Strength',
        description: 'Dual weapon conditioning for ambidextrous combat mastery',
        pattern: '=-[>)+',
        reps: 19,
        sets: 3,
        focus: 'Dual Mastery'
    },
    {
        id: 'night-riding-training',
        name: 'Night Riding Training',
        description: 'Nocturnal conditioning for mounts trained in silent movement',
        pattern: '>>==((',
        reps: 21,
        sets: 3,
        focus: 'Silent Movement'
    },
    {
        id: 'spy-mastery-conditioning',
        name: 'Spy Mastery Conditioning',
        description: 'The complete training for the most skilled scout and infiltrator',
        pattern: '>=-)+[!!',
        reps: 23,
        sets: 3,
        focus: 'Master Spy'
    }
];

// Main Knights Five trainers data object - Group Five
const knightsFiveTrainersData = {
    'sir-pelleas-the-younger': {
        id: 'sir-pelleas-the-younger',
        name: 'Sir Pelleas the Younger',
        title: 'Nephew to Sir Pelleas',
        specialization: 'Legacy Combat & Youthful Excellence',
        image: '/assets/images/Sir-Pelleas-the-Younger.jpg',
        experience: '18+ years',
        category: 'knights-five',
        color: '#E6E6FA',
        secondaryColor: '#C0C0C0',
        intro: `Young nephew to the great Sir Pelleas, following in his uncle's noble footsteps while seeking to forge his own legendary path. His light blue and silver surcoat bears the silver moon, symbolizing his growing potential. His training emphasizes that legacy is not inherited but earned, and that the greatest honors come to those who surpass their mentors.`,
        programs: pelleasYoungerPrograms
    },
    'sir-cador-of-cornwall': {
        id: 'sir-cador-of-cornwall',
        name: 'Sir Cador of Cornwall',
        title: 'Regional Lord of Cornwall',
        specialization: 'Regional Leadership & Coastal Defense',
        image: '/assets/images/Sir-Cador-of-Cornwall.jpg',
        experience: '45+ years',
        category: 'knights-five',
        color: '#000000',
        secondaryColor: '#FFD700',
        intro: `Distinguished lord of Cornwall who rules the rugged peninsula with wisdom and strength. His black and gold surcoat displays the ancient arms of Cornwall, while his regal bearing commands respect from all who serve under him. His training teaches that true leadership comes from understanding both the land you defend and the people you protect.`,
        programs: cadorPrograms
    },
    'sir-constantine-of-britain': {
        id: 'sir-constantine-of-britain',
        name: 'Sir Constantine of Britain',
        title: 'Knight of Ancient Blood',
        specialization: 'Tribal Warfare & Ancient Heritage',
        image: '/assets/images/Sir-Constantine-of-Britain.jpg',
        experience: '40+ years',
        category: 'knights-five',
        color: '#4169E1',
        secondaryColor: '#C0C0C0',
        intro: `Descendant of the ancient tribes of Britain who carries the blood of the original inhabitants in his veins. His deep blue surcoat decorated with silver Celtic knots connects him to the old ways, while his silver eagle shield represents the soaring spirit of ancient Britain. His training bridges the gap between primitive tribal strength and refined knightly skill.`,
        programs: constantinePrograms
    },
    'sir-lucan-the-butler': {
        id: 'sir-lucan-the-butler',
        name: 'Sir Lucan the Butler',
        title: 'Arthur\'s Faithful Servant',
        specialization: 'Service Combat & Administrative Warfare',
        image: '/assets/images/Sir-Lucan-the-Butler.jpg',
        experience: '35+ years',
        category: 'knights-five',
        color: '#4169E1',
        secondaryColor: '#FFD700',
        intro: `Arthur's most trusted servant who combines administrative excellence with deadly combat skill. His royal blue and gold surcoat bears the keys and crown of service, marking his unique position as both knight and steward. His training proves that the greatest strength often comes from those who serve others with unwavering loyalty and competence.`,
        programs: lucanPrograms
    },
    'sir-palamedes-the-saracen': {
        id: 'sir-palamedes-the-saracen',
        name: 'Sir Palamedes the Saracen',
        title: 'The Great Eastern Knight',
        specialization: 'Eastern Chivalry & Cultural Bridge',
        image: '/assets/images/Sir-Palamedes-the-Saracen.jpg',
        experience: '48+ years',
        category: 'knights-five',
        color: '#4169E1',
        secondaryColor: '#C0C0C0',
        intro: `The greatest Saracen knight who proves that chivalry knows no boundaries of race or religion. His magnificent blue silk surcoat decorated with silver crescents and stars represents the meeting of Eastern wisdom and Western valor. His training demonstrates that true nobility transcends cultural differences and that the greatest knights are those who bridge worlds.`,
        programs: palamedesPrograms
    },
    'sir-gaheris-of-orkney': {
        id: 'sir-gaheris-of-orkney',
        name: 'Sir Gaheris of Orkney',
        title: 'The Cunning Brother',
        specialization: 'Stealth Combat & Intelligence Warfare',
        image: '/assets/images/Sir-Gaheris-of-Orkney.jpg',
        experience: '32+ years',
        category: 'knights-five',
        color: '#228B22',
        secondaryColor: '#C0C0C0',
        intro: `The third brother of Gawain, known for his cunning and stealth rather than brute force. His forest green surcoat decorated with silver wolves reflects his ability to move unseen and strike from the shadows. His training teaches that sometimes the greatest victories come not from direct confrontation but from superior intelligence and careful planning.`,
        programs: gaherisPrograms
    }
};

// Export the data
export default knightsFiveTrainersData;